<template>
  <div class="row provider-details" v-if="profile.provider">
    <RedirectLink />
    <div class="contact-info-wrapper">
      <div class="contact-info">
        <div class="profile-img">
          <img
            class="company-profile-pic"
            v-if="profile.profilePhoto || profile.profilePhotoUrl"
            :src="signedUrl"
            :alt="profile.name"
          />
          <img v-else src="/img/icons/mask-group.svg" alt="" />
        </div>
        <div class="contact-info-details">
          <h3>
            {{ profile.name }}
          </h3>
          <template v-if="!jobseekerCompanyView">
            <span
              ><PhUser weight="fill" size="24px" />{{
                [profile.primaryUser?.firstName, profile.primaryUser?.lastName]
                  .filter(Boolean)
                  .join(" ")
              }}</span
            >
            <span
              ><PhMapPin weight="fill" size="24px" />{{ profile.city }},
              {{ profile.state }}</span
            >
            <span v-if="profile.phoneNumber"
              ><PhPhone weight="fill" size="24px" />{{
                profile.phoneNumber
              }}</span
            >
          </template>
        </div>
        <div
          class="contact-info-details second-column"
          v-if="!jobseekerCompanyView"
        >
          <span>
            <PhEnvelope weight="fill" size="24px" />
            <span class="wrap-long-text">{{ profile.email }}</span>
          </span>
          <span v-if="profile.website">
            <PhGlobe weight="fill" size="24px" />
            {{ profile.website }}
          </span>
        </div>
      </div>
      <!-- Todo: Add logic for connect with company -->
      <div class="warning" style="display: none">
        <div class="warning-text">Connect with company</div>
        <DefaultButton labelText="Connect" />
      </div>
    </div>
  </div>
</template>

<script>
import DefaultButton from "@/components/DefaultButton"
import RedirectLink from "@/components/RedirectLink"
import { PhMapPin, PhPhone, PhEnvelope, PhUser, PhGlobe } from "@phosphor-icons/vue"
import file from "@/api/file.js"
export default {
  components: {
    DefaultButton,
    PhMapPin,
    PhPhone,
    PhEnvelope,
    PhUser,
    PhGlobe,
    RedirectLink,
  },
  props: {
    profile: {
      type: Object,
      required: true,
    },
    applicant: {
      type: Boolean,
      default: false,
    },
    hasProfileViewAccess: {
      type: Boolean,
      default: false,
    },
    jobseekerCompanyView: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      signedUrl:
        typeof this.file === "string"
          ? this.file
          : "/img/icons/user-profile.svg",
    }
  },

  mounted() {
    this.loadFile()
  },

  methods: {
    async loadFile() {
      try {
        const fileId = this.profile.profilePhoto?.id
        if (fileId) {
          const { data } = await file.getThumbnailUrl({
            id: fileId,
            type: "small",
          })
          if (data?.url) {
            this.signedUrl = data.url
          } else if (data?.errors) {
            console.error(data.errors[0])
          }
        } else if (typeof this.file === "string") {
          this.signedUrl = this.file
        } else {
          this.signedUrl = "/img/icons/user-profile.svg"
        }
      } catch (error) {
        if (process.env.NODE_ENV === "development") {
          console.error(error)
        }
      }
    },
  },
  watch: {
    profile: {
      deep: true,
      handler() {
        this.loadFile()
      },
    },
  },
}
</script>

<style lang="scss" scoped>
.company-profile-pic {
  max-height: 100px !important;
  max-width: 100px !important;
  border-radius: unset !important;
}
.provider-details {
  display: flex;
  padding: 24px 96px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  background: var(--Gray-50, #f6f7f9);
  margin: 0;
  margin-bottom: 30px;

  .contact-info-wrapper {
    display: flex;
    width: 100%;

    .contact-info {
      display: flex;
      width: 100%;
      align-items: center;

      .profile-img {
        width: 104px;
        height: 104px;
        fill: var(--Gray-100, #eceef2);
        border-radius: 50%;
        margin-right: 32px;
        justify-content: center;
        display: flex;
        align-items: center;

        img {
          border-radius: 50%;
        }
      }

      .contact-info-details {
        display: flex;
        flex-direction: column;

        &.second-column {
          margin-left: 64px;
        }

        h3 {
          margin-bottom: 6px;
          font-size: 24px;
          font-weight: 700;
        }

        span {
          margin-top: 12px;
          font-size: 14px;

          svg {
            margin-right: 5px;
          }
        }
      }
    }
  }

  .warning {
    display: flex;
    padding: 20px 24px 24px 24px;
    flex-direction: column;
    align-items: center;
    border-radius: 8px;
    border: 1px solid var(--Blue-50, #d6e1f3);
    background: var(--White, #fff);
    min-width: 25%;

    .warning-text {
      margin-bottom: 16px;
      display: flex;
      align-items: center;
      font-size: 18px;
      font-weight: 600;
      color: var(--Gray-800, #3a4252);
      line-height: 140%;
    }

    .button-wrapper,
    .button-wrapper input {
      width: 100% !important;
    }
  }
}

@media (max-width: 480px) {
  .provider-details {
    padding: 20px !important;
  }
}

@media (max-width: 768px) {
  .contact-info {
    flex-direction: column;
    gap: 16px;

    .contact-info-details {
      width: 100%;
      span {
        white-space: nowrap;
      }

      h3 {
        text-align: center;
      }

      &.second-column {
        margin-left: 0 !important;
      }
      .wrap-long-text {
        word-wrap: break-word;
        white-space: normal;
      }
    }

    .profile-img {
      margin-right: 0 !important;
    }
  }
}
</style>
